import { type FC } from "react";

import { FeedbackRatingModelProvider } from "./FeedbackRatingModelProvider";
import { FeedbackRatingV1 } from "./FeedbackRatingV1";
import { TimeTillVisibleProvider } from "./TimeTillVisibleProvider";

interface FeedbackRatingContainer {
    timeTillVisibleInSeconds: number;
}

export const FeedbackRatingContainer: FC<FeedbackRatingContainer> = ({ timeTillVisibleInSeconds }) => {
    return (
        <TimeTillVisibleProvider timeTillVisibleInSeconds={timeTillVisibleInSeconds}>
            <FeedbackRatingModelProvider FeedbackRatingComponent={FeedbackRatingV1} />
        </TimeTillVisibleProvider>
    );
};
